const currentYear = new Date().getFullYear();

const COLUMNS = [
  {
    heading: 'Amarpura',
    links: [
      { href: '/', label: 'Home' },
      { href: '/about', label: 'About the village' },
      { href: '/contact-us', label: 'Contact us' },
    ],
  },
  {
    heading: 'Near By',
    links: [
      { href: '/modiya-mahadev', label: 'Modiya Mahadev' },
      { href: '/paangarh', label: 'Paangarh' },
      { href: '/bijaipur', label: 'Bijaipur' },
    ],
  },
  {
    heading: 'Getting here',
    links: [
      { href: '/about', label: 'Chittorgarh, Rajasthan' },
      { href: '/paangarh', label: 'Paangarh lake' },
    ],
  },
];

const Footer = () => (
  <footer className="footer" role="contentinfo">
    <div className="container">
      <div className="footer__cols">
        {COLUMNS.map(({ heading, links }) => (
          <div key={heading}>
            <h2>{heading}</h2>
            <ul>
              {links.map(({ href, label }) => (
                <li key={href + label}>
                  <a href={href}>{label}</a>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
      <div className="footer__base">
        <p>&copy; 2013&ndash;{currentYear} Amarpura. All rights reserved.</p>
      </div>
    </div>
  </footer>
);

export default Footer;
